import { AuxiliumComponent } from "../auxilium-component";

export class Range extends AuxiliumComponent {
	static observedAttributes = ["value"];

	#Input = null;

	constructor() {
		super();

		this.identifier = this.getAttribute("identifier") ?? crypto.randomUUID().slice(0, 8);
		this.label = this.getAttribute("label") ?? "";
		this.helperText = this.getAttribute("helper-text") ?? "";
		this.min = this.getAttribute("min") ?? "0";
		this.max = this.getAttribute("max") ?? "100";
		this.value = this.getAttribute("value") ?? "0";
		this.step = this.getAttribute("step") ?? "1";
	}

	parsedCallback() {
		this.#Input = document.createElementWithContents("input", null, {
			type: "range",
			min: this.min,
			max: this.max,
			id: this.identifier,
			value: this.value,
			step: this.step,
			oninput: () => this.value = this.#Input.value
		});

		this.value = this.#Input.value
		this.#UpdateTrack();

		if (this.label) {
			this.appendChild(document.createElementWithContents("label", this.label, {
				className: "input-field__label",
				htmlFor: this.identifier
			}));
		}

		this.appendChild(document.createElementWithContents("div", this.#Input, { className: "range--track" }));

		if (this.helperText) {
			this.appendChild(document.createElementWithContents("div", this.helperText, { className: "input-field__helper-text" }));
		}
	}

	#UpdateTrack() {
		const percentage = 100 * (parseFloat(this.#Input.value) - parseFloat(this.min)) / (parseFloat(this.max) - parseFloat(this.min));
		this.#Input.style.background = `linear-gradient(to right, var(--range-bar-active-colour) ${percentage}%, var(--range-bar-colour) ${percentage}%)`;
	}

	attributeChanged(name, _, newValue) {
		if (name === "value") {
			this.#Input.value = newValue;
			this.#UpdateTrack();
		}
	}
}